import mobilemedImg from "../../assets/img/mobilemed-icon.svg";

type RecoveryAccountHeaderProps = {
  title: string;
};

export function RecoveryAccountHeader({ title }: RecoveryAccountHeaderProps) {
  return (
    <div
      className="d-flex flex-wrap align-items-center px-3 py-2 border-bottom mb-4"
      style={{ background: "#f8f9fa" }}
    >
      <img
        src={mobilemedImg}
        alt="MobileMed"
        style={{ width: 40, marginRight: 12 }}
      />
      <span className="fw-bold" style={{ color: "#1266f1" }}>
        {title}
      </span>
    </div>
  );
}
